import styled from "styled-components";

export const DeadlineWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[1]};
  font-size: ${({ theme }) => theme.fontSizes[4]};
`;

export const DeadlineDate = styled.time`
  color: ${({ theme }) => theme.colors.greyLight2};
`;
